import React from 'react'
import './todosLibros.css';
import { useEffect, useState } from 'react'
import { useAxios } from '../../../hooks/useAxios'
import { useCounter } from '../../../hooks/useCounter';
import { useTodosLibros, useTodosLibros_Mov } from './useTodosLibros';
import { useTranslation } from "react-i18next";

const pagin = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const pagin_mov = [1, 2, 3, 4, 5];
const rut = 'https://www.ricardosalinas.com/images/libros/';

const TodosLibros = ({books}) => {

    const { counter, increment, decrement, defaultValue } = useCounter(0);
    const { libros, isloading, error } = useTodosLibros({ counter, books })
    const { libros_mov, isloading_mov, error_mov } = useTodosLibros_Mov({ counter, books })
    const [t, i18n] = useTranslation("biblioteca");

    const total=counter*12;
    const totalm=counter*6;

    //const { data, isloading, error } = useAxios('/library/nbooks2?offset=0&next=12&sitioid=2&lenguaje=es');
    const [book, setBook] = useState(null);
    const [bookMov, setBookMov] = useState(null);

     useEffect( () => {
         if(libros){
             setBook(libros);

         }
     }, [libros])

     useEffect( () => {
         if(libros_mov){
             setBookMov(libros_mov);

         }
     }, [libros_mov])

  return (
    <div class="biblio_todos_cont">
        <div class="contenedor_bi">
            {/* <div class="row1_bi dista">
                <div class="col1">
                    <p class="titulo_bi">{(t('biblioteca.titulo'))}
                    </p>
                    <p class="descrip_bi2">{(t('biblioteca.descripcion'))}</p>
                    <p class="descrip_bi3">{(t('biblioteca.conocelos'))}</p>
                </div>
            </div>*/}
            <div class="row1_bp">
                <p class="result_bp">{(t('biblioteca.mostrando'))} 110 {(t('biblioteca.resultados'))}</p>
                <p class="result_bp_mov">{(t('biblioteca.mostrando'))} 110 {(t('biblioteca.resultados'))}</p>
            </div> 
            <div class="row2_bp escritorio">
                <div class="list_content--items_bp">
                    {
                        (isloading || book === null) ?
                            (<h1>Esta cargando</h1>) :
                            (
                                <>
                                    {
                                        book.map((item, index) => (
                                            <div class="card">
                                                <div class="front">
                                                    <img class="imgG_bp" src={rut + item.imagen} alt={item.imagen.substring(0, item.imagen.length - 4)} />
                                                    <div class="cinta_bp">
                                                        <p class="tit_bp">{item.titulo.split(":")[0]}</p>
                                                    </div>
                                                </div>

                                                <div class="back">

                                                    {/* <p class="titu_bp">{item.titulo}
                                                        </p> */}
                                                    <p class="titu_bp">{item.titulo.split(":")[0]}
                                                    </p>
                                                    <p class="desc_bp">{item.descripcion.substring(0, 155) + '...'}
                                                    </p>
                                                    <p class="alineIzq_ub_bp aut_bp">{item.autor}
                                                    </p>
                                                    <p class="alineIzq_ub_bp daut_bp">{item.editorial}
                                                    </p>
                                                    <p class="alineIzq_ub_bp fh_bp"> {item.fecha.substring(6, 10)}  </p>

                                                    {/* <a class="buton_bp" target="_blank" href="#">Ver más</a> */}
                                                    <div class="div_bot1_bp">

                                                        <a class="buton_bp" target="_blank" href="#">{(t('biblioteca.ver-mas'))}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                            )
                    }
                </div>
                {/* <div id="column-left_bp" >
                    <div class="row6_bp">
                        {   
                            counter > 0 ? 
                            (<img class="imgPag_bp" onClick={ () => decrement() } src='/assets/imgs/detalle_blog/arrow.png'/>) :
                            (<div></div>)
                        }
                    </div>
                    <div class="row6_bp">
                        {
                            (counter > 0 && book === null) ?
                            (<div></div>):
                            (<img class="imgPag_bp_dr" onClick={ () => increment() } src='/assets/imgs/detalle_blog/arrow.png'/>)
                        }
                    </div>
                    {
                        pagin.map((item, index) => (
                            <div div class="row6_bp">
                                <p class="nume" key={index} onClick={ () => defaultValue(index)}>
                                    {item}
                                </p>
                            </div>
                        ))
                    }
                </div> */}
            </div>
            <div class="row2_bp movil">
                {/* <div class="column-arriba" >
                    <div class="row6_bp_movil">
                        {   
                            counter > 0 ? 
                            (<img class="imgPag_bp_mov" onClick={ () => decrement() } src='/assets/imgs/detalle_blog/arrow.png'/>) :
                            (<div></div>)
                        }
                        <img class="imgPag_bp_mov" src={regresa2} alt="ir" />
                        {
                            pagin_mov.map((item, index) => (
                                // <div div class="row6_bp">
                                <p class="nume_mov" key={index} onClick={ () => defaultValue(item)}>
                                    {item}
                                </p>
                                // </div>
                            ))
                        }
                        <p class="nume_mov"> ... </p>
                        {
                            (counter > 0 && book === null) ?
                            (<div></div>):
                            (<img class="imgPag_bp_mov_der" onClick={ () => increment() } src='/assets/imgs/detalle_blog/arrow.png'/>)
                        }
                         <img class="imgPag_bp_mov" src={ir} alt="regresa" /> 

                    </div>
                </div> */}

                <div class="list_content--items_bp">

                    {
                        (isloading_mov || bookMov === null) ?
                            (<h1>Esta cargando</h1>) :
                            (
                                <>
                                    {
                                        bookMov.map((item, index) => (
                                            <div class="card" key={index}>
                                                <div class="front">
                                                    <img class="imgG_bp" src={rut + item.imagen} alt={item.imagen.substring(0, item.imagen.length - 4)} />
                                                    <div class="cinta_bp">
                                                        <p class="tit_bp">{item.titulo.split(":")[0]}</p>
                                                    </div>
                                                </div>
                                                <div class="back">
                                                    {/* <p class="titu_bp">{item.titulo}
                                                </p> */}
                                                    <p class="titu_bp">{item.titulo.split(":")[0]}
                                                    </p>
                                                    <p class="desc_bp">{item.descripcion.substring(0, 90) + '...'}
                                                    </p>
                                                    <p class="alineIzq_ub_bp aut_bp">{item.autor}
                                                    </p>
                                                    <p class="alineIzq_ub_bp daut_bp">{item.editorial}
                                                    </p>
                                                    <p class="alineIzq_ub_bp fh_bp"> {item.fecha.substring(6, 10)}  </p>

                                                    {/* <a class="buton_bp" target="_blank" href="#">Ver más</a> */}
                                                    <div class="div_bot1_bp">

                                                        <a class="buton_bp" target="_blank" href="#">{(t('biblioteca.ver-mas'))}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                            )
                    }
                </div>
            </div>

            <div class="row3_bp">
                <p class="result_bp">{(t('biblioteca.mostrando'))} 110 {(t('biblioteca.resultados'))}</p>
                <p class="result_bp_mov">{(t('biblioteca.mostrando'))} 110 {(t('biblioteca.resultados'))}</p>
            </div>
        </div>
    </div>
  )
}

export default TodosLibros
